import React, { FC, useCallback, useContext } from 'react'
import { useEditor } from '@craftjs/core'

import Divider from '@mui/material/Divider'
import Box from '@mui/material/Box'

import EditorContext from './EditorContext'
import TinyButton from '../widgets/TinyButton'
import useEditorActions from './useEditorActions'
import icons from '../../icons'
import PreviewButton from './PreviewButton'

import {
  ILayout,
} from '@kaidam/fc-shared/src/types/layout'

import {
  extractSetValue,
} from './utils'

interface ItemToolbarProps {
  withInitialDivider?: boolean,
  onChange: {
    (data: ILayout): void,
  },
}

const ItemToolbar: FC<React.PropsWithChildren<ItemToolbarProps>> = ({
  withInitialDivider = true,
  onChange,
}) => {

  const editorContext = useContext(EditorContext)

  const {
    exportLayout,
    deselect,
  } = useEditorActions()

  const {
    id,
    type,
    locked,
  } = useEditor((state, utils) => {
    let id = ''
    let type = ''
    let locked = false
    if(state.events.selected) {
      id = extractSetValue(state.events.selected)
      const node = state.nodes[id]
      if(node) {
        type = node.data.displayName
        if(type != 'cell' && type != 'row') id = ''
        locked = node.data.props.config?.locked ? true : false
      }
    }
    return {
      id,
      type,
      locked,
    }
  })

  const onSave = useCallback(() => {
    onChange(exportLayout(editorContext.options))
  }, [
    onChange,
  ])

  const onEdit = useCallback(() => {
    editorContext.setEditorEvent({id, action: 'edit'})
  }, [
    id,
    editorContext,
  ])

  const onDelete = useCallback(() => {
    editorContext.setEditorEvent({id, action: 'delete'})
  }, [
    id,
    editorContext,
  ])
  
  return (
    <Box
      className='root'
      sx={{
        height: '100%',
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        p: 1,
      }}
    >
      {
        id && (
          <Box>
            {
              withInitialDivider && (
                <Divider
                  className='divider'
                  sx={{
                    mx: 1,
                    minHeight: '20px',
                  }}
                  orientation="vertical"
                />
              )
            }
              <TinyButton
                size="small"
                onClick={ deselect }
              >
                Back
              </TinyButton>
            {
              type == 'cell' && (!editorContext.options.lockedCells || !locked) && (
                <TinyButton
                  size="small"
                  onClick={ onEdit }
                >
                  Edit
                </TinyButton>
              )
            }
            {
              !editorContext.options.disableDelete && (!editorContext.options.lockedCells || !locked) && (
                <TinyButton
                  color='error'
                  size="small"
                  onClick={ onDelete }
                >
                  Delete
                </TinyButton>
              )
            }
          </Box>
        )
      }
    </Box>
  )

}

export default ItemToolbar